import { render, staticRenderFns } from "./campaign-email-toggle.vue?vue&type=template&id=5eb35310&"
import script from "./campaign-email-toggle.vue?vue&type=script&lang=js&"
export * from "./campaign-email-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports